
import { toast } from "sonner";

/**
 * Handle and log errors with toast notifications
 */
export function handleError(error: unknown, message: string): void {
  console.error(`${message}:`, error);
  toast.error(message);
}
